import InUse from "../images/Bookcase/1InUse.jpeg"
import Wood from "../images/Bookcase/2Wood.jpeg"
import Router from "../images/Bookcase/3Router.jpeg"
import Pieces from "../images/Bookcase/4Pieces.jpeg"
import Bottom from "../images/Bookcase/5Bottom.jpeg"
import Assembly from "../images/Bookcase/6Assembly.jpeg"
import FullAssembly from "../images/Bookcase/7FullAssembly.jpeg"
import Sanding from "../images/Bookcase/8Sanding.jpeg"
import Colors from "../images/Bookcase/9Colors.jpeg"
import Painting from "../images/Bookcase/10Painting.jpeg"
import TurnTable from "../images/Bookcase/11TurnTable.jpeg"
import Stain from "../images/Bookcase/12Stain.jpeg"
import Trim from "../images/Bookcase/13Trim.jpeg"
import Doorknobs from "../images/Bookcase/14Doorknobs.jpeg"
import SansLight from "../images/Bookcase/15SansLight.jpeg"
import Idea from "../images/Bookcase/16Idea.jpeg"

const BookcaseImages = [
  {
    src: InUse,
    text: "The finished product in use at my parents home in Kansas."
  },
  {
    src: Wood,
    text: "I was careful to source only the best looking pieces for this project."
  },
  {
    src: Router,
    text: "The router used to create the notches the shelves would fit into."
  },
  {
    src: Pieces,
    text: "Putting the pieces together with the help of my late father, and mentor."
  },
  {
    src: Bottom,
    text: "The bottom of the bookcase after finishing nailing on the sides and shelves."
  },
  {
    src: Assembly,
    text: "Everything in place except the top."
  },
  {
    src: FullAssembly,
    text: "All the pieces in place."
  },
  {
    src: Sanding,
    text: "I decided I wanted the edges of the top, bottom, and shelves to be rounded, which involved much sanding."
  },
  {
    src: Colors,
    text: "I love teal, so I decided to go with a chalk paint in that color along with metallic accents in bronze."
  },
  {
    src: Painting,
    text: "It took several coats to get full saturation. I love how you can see the wood grain here."
  },
  {
    src: TurnTable,
    text: "I had the idea to put the whole thing on a turntable so all angles could be accessed."
  },
  {
    src: Stain,
    text: "The stain makes the piece look aged and matched the metallic accents."
  },
  {
    src: Trim,
    text: "Next, the metallic trim got cut and tacked on with upholstery tacks to hold in in place."
  },
  {
    src: Doorknobs,
    text: "I had found some interested doorknobs that matched the project and added them as a means to turn the bookcase by hand. In the end they had to be reattached with metal, as the first wooden solution ended up breaking."
  },
  {
    src: SansLight,
    text: "The finished product... almost."
  },
  {
    src: Idea,
    text: "I had the random idea to light the bookcase from the inside, which I first prototyped with a rope light. I ended up going with LED strip lights in the end. Thank goodness they are dimmable!"
  } 
]

export default BookcaseImages;
